
  <div class="row">
    <div class="col-lg-12 grid-margin">
      <div class="card">
        <div class="card-body upper-header">
            <div class="row">
                <div class="form-group col-1.5 mr-2">
                  <label>Date of visit</label>
                  <input class="form-control border-primary" [owlDateTime]="dt" placeholder="Date" name="visit_date"
                    [(ngModel)]="visit_date" readonly>
                  <span [owlDateTimeTrigger]="dt" class="date-ico"><i class="fa fa-calendar"></i></span>
                  <owl-date-time #dt [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                </div>

                <div class="form-group col-2 mr-2">
                    <label>Mobile Number</label>
                    <input type="text"
                    maxlength="10"
                    class="form-control border-primary"
                    placeholder="Enter mobile no"
                    [(ngModel)]="mobile_no"
                    name="mobile_no">
                </div>
                
                <div class="form-group col-1.5">
                  <button type="button" style="margin-top: 30px;" class="btn btn-inverse-primary btn-fw top-btn-head" (click)="getList($event)">Load</button>
                </div>
              </div>
          <h4 class="card-title">
            <div class="d-flex bd-highlight">
              <div class="p-2 flex-grow-1 bd-highlight">Visitor Payment Verification</div>
            </div>
          </h4>
          <div class="table-responsive" *ngIf="payment_verification && payment_verification && payment_verification.length">
            <table class="table">
              <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Mobile Number</th>
                <th>Date of visit</th>
                <th>Number of person</th>
                <th>Payment Status</th>
                <th>Created at</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let data of payment_verification; let i = index">
                <td>
                  <span *ngIf = "page == 1">{{i+1}}</span>
                  <span *ngIf = "page > 1">{{((page - 1 )*perPage) + (i+1)}}</span>
                </td>
                <td>{{data?.first_name}} {{data?.last_name}}</td>
                <td>{{data?.mobile_no}}</td>
                <td>{{data?.date_of_visit}}</td>
                <td>{{data?.visitor_details_count}}</td>
                <td>{{data?.payment_status}}</td>
                <td>{{data?.created_at}}</td>
                <!-- <td>{{data?.payments[0]?.amount}}</td> -->
                <td>
                    <span *ngIf="data?.payment_status != 'Paid'">
                        <button class="btn btn-primary" (click)="verifyPayment(data?.id)">Verify</button>
                    </span>
                </td>

              </tr>
              </tbody>
            </table>
          </div>

          <div class="p-12" *ngIf="payment_verification && payment_verification && !payment_verification.length">
            <span class="ng-star-inserted no_data" >No Data found.</span>
          </div>
          <!-- <ngb-pagination *ngIf="payment_verification && payment_verification.data && payment_verification.data.length" [collectionSize]="totalCount" [pageSize]="perPage"
          [(page)]="page" (pageChange)="getList('pagination')" [maxSize]="3"
          class="pull-right justify-content-end page-mt-10"
          aria-label="Default pagination"></ngb-pagination> -->
        </div>
      </div>
    </div>
  </div>

